// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EQw0Ce6Zb6uS-RXunCnLV{display:block;position:relative;max-width:2.14286rem;max-height:2.14286rem;height:100%;animation:_1Pyb857v4tSTzjT67L8crM 1.8s infinite linear}@keyframes _1Pyb857v4tSTzjT67L8crM{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": "EQw0Ce6Zb6uS-RXunCnLV",
	"rotation": "_1Pyb857v4tSTzjT67L8crM"
};
export default ___CSS_LOADER_EXPORT___;
